import React from 'react';
import { isIndividual, isForProfit, isNonProfit, isNPO, getOrgInfo, ORG_TYPE_LABELS } from '../../constants/orgTypes';

export const Sidebar = ({
    currentPage,
    setCurrentPage,
    currentFiscalYear,
    setCurrentFiscalYear,
    fiscalYears,
    fileSystem,
    hasUnsavedChanges,
    user,
    onLogout,
    accountType,
    orgType,
    onCreateYear
}) => {
    const isKojin = accountType === 'kojin';
    const navItems = [
        { id: 'dashboard', label: 'ダッシュボード' },
        { id: 'journals', label: '仕訳入力' },
        { id: 'accounts', label: '勘定科目マスタ' },
        { id: 'ledger', label: '総勘定元帳' },
        { id: 'trial-balance', label: '試算表' },
        { id: 'financial-statements', label: '決算書' },
        { id: 'tax-summary', label: '消費税集計' },
        { id: 'fixed-assets', label: '固定資産台帳' },
        { id: 'card-settlement', label: 'カード消込' },
        { id: 'closing-wizard', label: '決算整理' },
        ...(isIndividual(orgType) ? [{ id: 'deductions', label: '所得控除' }] : []),
        ...(isNPO(orgType) ? [] : [{
            id: 'etax',
            label: isIndividual(orgType) ? 'e-Tax転記用' :
                   isNonProfit(orgType) ? '法人税申告用' : 'e-Tax転記用'
        }]),
        { id: 'data-management', label: 'データ管理' },
        { id: 'help', label: 'ヘルプ' },
    ];

    const getYearPeriod = (fiscalYear) => {
        const { year, endMonth } = fiscalYear;
        if (isKojin) {
            return `${year}年（${year}/1〜${year}/12）`;
        }
        const startMonth = endMonth === 12 ? 1 : endMonth + 1;
        const startYear = endMonth === 12 ? year : year;
        const endYear = endMonth === 12 ? year : year + 1;
        return `${year}年度（${startYear}/${startMonth}〜${endYear}/${endMonth}）`;
    };

    const orgInfo = getOrgInfo();
    const orgTypeLabel = orgInfo ? ORG_TYPE_LABELS[orgInfo.type] : '';
    const fiscalPeriod = orgInfo?.foundingYear ? currentFiscalYear - orgInfo.foundingYear + 1 : null;

    const sidebarStyle = isIndividual(orgType) ? {background: 'linear-gradient(180deg, #42a5f5 0%, #1e88e5 100%)'} :
        isForProfit(orgType) ? {background: 'linear-gradient(180deg, #3498db 0%, #2980b9 100%)'} :
        {};

    const existingYears = fiscalYears.map(fy => fy.year);
    const maxYear = existingYears.length > 0 ? Math.max(...existingYears) : new Date().getFullYear();
    const nextYear = maxYear + 1;
    const hasNextYear = existingYears.includes(nextYear);

    const handleYearChange = async (e) => {
        const selectedYear = Number(e.target.value);

        if (selectedYear === nextYear && !hasNextYear) {
            const yearLabel = isKojin ? `${nextYear}年` : `${nextYear}年度`;
            if (confirm(`${yearLabel}の帳簿がまだありません。作成しますか？\n\n勘定科目は前年度からコピーされます。`)) {
                if (onCreateYear) {
                    await onCreateYear(nextYear);
                }
            }
            return;
        }

        setCurrentFiscalYear(selectedYear);
    };

    return (
        <nav className="sidebar" style={sidebarStyle}>
            <div className="sidebar-header">
                <h1>{isIndividual(orgType) ? 'トイロ青色申告' : 'トイロ法人会計'}</h1>
                {!isIndividual(orgType) && orgTypeLabel && <span style={{fontSize: '12px', opacity: 0.8}}>{orgTypeLabel}</span>}
                {orgInfo?.name && <h2>{orgInfo.name}</h2>}
                {fiscalPeriod > 0 && <span style={{fontSize: '11px', opacity: 0.7}}>第{fiscalPeriod}期</span>}
                {user && (
                    <div className="user-info">
                        {user.picture && <img src={user.picture} alt="" />}
                        <div className="user-info-text">
                            <span>{getOrgInfo()?.name || user.name || user.email}</span>
                            <button className="logout-btn" onClick={onLogout}>ログアウト</button>
                        </div>
                    </div>
                )}
            </div>

            <div className="fiscal-year-selector">
                <select
                    value={currentFiscalYear}
                    onChange={handleYearChange}
                >
                    {!hasNextYear && (
                        <option key={nextYear} value={nextYear} style={{color: '#666'}}>
                            + {isKojin ? `${nextYear}年を作成` : `${nextYear}年度を作成`}
                        </option>
                    )}
                    {fiscalYears.map(fy => (
                        <option key={fy.year} value={fy.year}>
                            {getYearPeriod(fy)}
                        </option>
                    ))}
                </select>
            </div>

            <div className="nav-section">メニュー</div>

            {navItems.map(item => (
                <div
                    key={item.id}
                    className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                    onClick={() => setCurrentPage(item.id)}
                >
                    {item.label}
                </div>
            ))}

            <div className={`storage-status ${fileSystem.isConnected ? 'connected' : 'disconnected'}`}>
                {fileSystem.isConnected ? (
                    <div>{hasUnsavedChanges ? '保存中...' : '保存済み'}</div>
                ) : (
                    <div>一時保存中</div>
                )}
            </div>
        </nav>
    );
};

export default Sidebar;
